import { IdProvider } from '../provider';

const wait = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

const getSnowplowLoadStatus = (): boolean | null | undefined => window.snowplow.__vs__?.isLoaded;
const waitForSnowplowSdk = async(): Promise<boolean> => {
  while (true) { // Loop indefinitely
    const status = getSnowplowLoadStatus();
    if (status === undefined) {
      // TODO: Log this to sentry
      // eslint-disable-next-line no-console
      console.error('The logic for checking snowplow script loading is not initialized');
    }

    switch (status) {
      case null: {
        await wait(10);
        break;
      }
      case true: {
        return true;
      }
      case false:
      case undefined:
      default: {
        return false;
      }
    }
  }
};

export interface CreateSnowplowIdProviderOptions {
  namespace: string;
}

export const createSnowplowIdProvider = (config: CreateSnowplowIdProviderOptions): IdProvider => {
  const namespace = config.namespace;

  return {
    async get(): Promise<string | null> {
      const isLoaded = await waitForSnowplowSdk();
      if (!isLoaded) return null;

      return new Promise<string | null>(resolve => {
        (window.snowplow as any)(function _(this: any) {
          const domainUserId = this[namespace].getDomainUserId();
          resolve(domainUserId ?? null);
        });
      });
    },
  };
};
